import React, { useContext } from 'react'
import ProxyContext from './context'

export default function useProxy() {
  const context = useContext(ProxyContext)

  if (!context)
    throw new Error('useProxy must be used within the ProxyProvider')

  return context
}